import React from "react";

const ExclamationIcon = (props) => {
  return (
    <svg
      viewBox="0 0 128 512"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      width="12"
      height="12"
      {...props}
    >
      <path
        d="M64 432c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40c0-22.1 17.9-40 40-40zM64 0c26.5 0 48 21.5 48 48 0 .6 0 1.1 0 1.7l-16 304c-.9 17-15 30.3-32 30.3S33 370.7 32 353.7L16 49.7c0-.6 0-1.1 0-1.7 0-26.5 21.5-48 48-48z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ExclamationIcon;
